import "./WorkoutAttachments.css";
import React, { useState, useEffect } from "react";
import UploadAttachment from "./UploadAttachment";
import AttachmentModel from "./AttachmentModel";
import AddAttachment from "./AddAttachment";
import { ToastContainer } from "react-toastify";
import { FirebaseServices } from "../../api/FirebaeServices";
import { toast } from "react-toastify";
import AttachmentServices from "../../api/AttachmentServices";
import axios from "axios";

const WorkoutAttachments = ({
  // setAttachmentModal,
  programId,
  workoutId,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [isEdit, setIsEdit] = useState(false);
  const [attachmetTitle, setAttachmenttitle] = useState("");
  const [selectedFile, setSelectedFile] = useState("");
  const [attachmentsList, setAttachmentsList] = useState([]);
  const [isUploading, setIsUpLoading] = useState(false);
  const userId = localStorage.getItem("metauserid") || "";
  const [selectedAttachment, setSelectedAttachment] = useState({});
  const [attachmentLink, setAttachmetLink] = useState("");

  const makingVariableEmpty = () => {
    setProgress(0);
    setIsEdit(false);
    setAttachmenttitle("");
    setAttachmetLink("");
    setSelectedFile("");
    setIsUpLoading(false);
    setSelectedAttachment({});
  };

  const showError = (error) => {
    makingVariableEmpty();
    return toast.error(error, {
      autoClose: 3000,
      pauseOnHover: true,
      draggable: true,
    });
  };

  // api call to get workout attachment
  const getWorkoutAttachments = async () => {
    setLoading(true);

    if (workoutId == 0){
      try {
        const result = await AttachmentServices.getProgramAttachments(programId);
        if (result?.data?.success === true) {
          setLoading(false);
          setAttachmentsList(result?.data?.data);
        } else {
          setLoading(false);
          toast.error(result?.data?.message, {
            autoClose: 1000,
            pauseOnHover: true,
            draggable: true,
          });
        }
      } catch (error) {
        setLoading(false);
        toast.error(error?.result?.data?.errors[0], {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
        });
      }
    }else{
      try {
        const result = await AttachmentServices.getWorkoutAttachments(workoutId);
        if (result?.data?.success === true) {
          setLoading(false);
          setAttachmentsList(result?.data?.data);
        } else {
          setLoading(false);
          toast.error(result?.data?.message, {
            autoClose: 1000,
            pauseOnHover: true,
            draggable: true,
          });
        }
      } catch (error) {
        setLoading(false);
        toast.error(error?.result?.data?.errors[0], {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
        });
      }
    }
    makingVariableEmpty();
  };

  // api call to add new workout attachment
  const addWorkoutAttachment = async (link, type, size) => {
    if (workoutId == 0){

      const data = new FormData();
      data.append("program_id", programId);
      data.append("title", attachmetTitle);
      if (type) data.append("type", type);
      else data.append("type", attachmentLink.split("/").pop().split(".").pop());
      if (link) data.append("link", link);
      if (size) data.append("size", size);
      data.append("user_id", userId);
  
      try {
        const result = await AttachmentServices.addProgramAttachment(data);
        console.log(result);
        if (result?.data?.success === true) {
          toast.success(result?.data?.message, {
            autoClose: 1000,
            pauseOnHover: true,
            draggable: true,
          });
          getWorkoutAttachments();
          handleCloseModal(); // Close modal after successful upload
        } else {
          setLoading(false);
          toast.error(result?.data?.message, {
            autoClose: 1000,
            pauseOnHover: true,
            draggable: true,
          });
        }
      } catch (error) {
        setLoading(false);
        toast.error(error?.result?.data?.errors[0], {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
        });
      }

    }else{
      const data = new FormData();
      data.append("program_id", programId);
      data.append("workout_id", workoutId);
      data.append("title", attachmetTitle);
      if (type) data.append("type", type);
      else data.append("type", attachmentLink.split("/").pop().split(".").pop());
      if (link) data.append("link", link);
      if (size) data.append("size", size);
      data.append("user_id", userId);
  
      try {
        const result = await AttachmentServices.addWokroutAttachment(data);
        console.log(result);
        if (result?.data?.success === true) {
          toast.success(result?.data?.message, {
            autoClose: 1000,
            pauseOnHover: true,
            draggable: true,
          });
          getWorkoutAttachments();
          handleCloseModal(); // Close modal after successful upload
        } else {
          setLoading(false);
          toast.error(result?.data?.message, {
            autoClose: 1000,
            pauseOnHover: true,
            draggable: true,
          });
        }
      } catch (error) {
        setLoading(false);
        toast.error(error?.result?.data?.errors[0], {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
        });
      }
    }
  };

  // api call to update workout attachment
  const updateWorkoutAttachment = async (link, type, size) => {
    if (workoutId == 0){

      const data = new FormData();
      data.append("id", selectedAttachment.id);
      data.append("program_id", programId);
      if (attachmetTitle) data.append("title", attachmetTitle);
      if (type) data.append("type", type);
      if (link) data.append("link", link);
      if (size) data.append("size", size);
      else data.append("size", 0);
      data.append("user_id", userId);
  
      try {
        const result = await AttachmentServices.updateProgramAttachment(data);
        console.log(result);
        if (result?.data?.success === true) {
          toast.success(result?.data?.message, {
            autoClose: 1000,
            pauseOnHover: true,
            draggable: true,
          });
          getWorkoutAttachments();
          handleCloseModal(); // Close modal after successful update
        } else {
          setLoading(false);
          toast.error(result?.data?.message, {
            autoClose: 1000,
            pauseOnHover: true,
            draggable: true,
          });
        }
      } catch (error) {
        setLoading(false);
        toast.error(error?.result?.data?.errors[0], {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
        });
      }

    }else{
      const data = new FormData();
      data.append("id", selectedAttachment.id);
      data.append("workout_id", workoutId);
      if (attachmetTitle) data.append("title", attachmetTitle);
      if (type) data.append("type", type);
      if (link) data.append("link", link);
      if (size) data.append("size", size);
      else data.append("size", 0);
      data.append("user_id", userId);
  
      try {
        const result = await AttachmentServices.updateWokroutAttachment(data);
        console.log(result);
        if (result?.data?.success === true) {
          toast.success(result?.data?.message, {
            autoClose: 1000,
            pauseOnHover: true,
            draggable: true,
          });
          getWorkoutAttachments();
          handleCloseModal(); // Close modal after successful update
        } else {
          setLoading(false);
          toast.error(result?.data?.message, {
            autoClose: 1000,
            pauseOnHover: true,
            draggable: true,
          });
        }
      } catch (error) {
        setLoading(false);
        toast.error(error?.result?.data?.errors[0], {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
        });
      }
    }

  };

  // api call to delete workout attachment
  const deleteWokroutAttachment = async (workout) => {
    setLoading(true);
    if (workoutId == 0){

      try {
        const prams = `program_id=${programId}&id=${workout?.id}`;
        const result = await AttachmentServices.deleteProgramAttachment(prams);
        if (result?.data?.success === true) {
          getWorkoutAttachments();
        } else {
          setLoading(false);
          toast.error(result?.data?.message, {
            autoClose: 1000,
            pauseOnHover: true,
            draggable: true,
          });
        }
      } catch (error) {
        setLoading(false);
        toast.error(error?.result?.data?.errors[0], {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
        });
      }

    }else{
      try {
        const prams = `workout_id=${workoutId}&id=${workout?.id}`;
        const result = await AttachmentServices.deleteWokroutAttachment(prams);
        if (result?.data?.success === true) {
          getWorkoutAttachments();
        } else {
          setLoading(false);
          toast.error(result?.data?.message, {
            autoClose: 1000,
            pauseOnHover: true,
            draggable: true,
          });
        }
      } catch (error) {
        setLoading(false);
        toast.error(error?.result?.data?.errors[0], {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
        });
      }
    }
  };

  useEffect(() => {
    getWorkoutAttachments();
  }, []);



  const handleUploadFile = async () => {
    if (!selectedFile) {
      showError("No File Selected");
      return;
    }

    const fileSizeInMB = selectedFile.size / (1024 * 1024);
    if (fileSizeInMB > 250) {
      showError("File size exceeds 250 MB limit.");
      return;
    }

    const fileType = selectedFile.type.split("/").pop().split(".").pop();
    if (!fileType) {
      showError("Invalid File Type");
      return;
    }

    setIsUpLoading(true);

     try {
      const { uploadTask, fileLink } = await FirebaseServices.fileUpload(
        selectedFile,
        setProgress
      );

      if (fileLink) {
        isEdit
          ? updateWorkoutAttachment(fileLink, fileType, fileSizeInMB)
          : addWorkoutAttachment(fileLink, fileType, fileSizeInMB);
      } else {
        showError("Failed To Upload File");
      }
    } catch (error) {
      showError("Failed To Upload File");
    } finally {
      setIsUpLoading(false);
      setLoading(false);
    }
   
    // Don't close modal here - let the success callbacks handle it
  };

  

async function uploadToGCS(uploadUrl, file, onProgress) {
  // Upload the entire file in one request for GCS resumable upload
  
  try{
     
      await axios.put(uploadUrl, file, {
        headers: {
          "Content-Type": file.type,
          "Content-Length": file.size,
          "Content-Range": `bytes 0-${file.size - 1}/${file.size}`,
        },
      });
/*
    console.log("Uploading file to GCS:", file.name);
    const res = await fetch(uploadUrl, {
    method: "PUT",
    headers: {
      "Content-Type": file.type,
      //"Content-Length": file.size,
      },
      body: file,
    });

    if (!res.ok) {
      throw new Error("Upload failed");
    }

    if (onProgress) {
      onProgress(100);
    }*/

    console.log("✅ Upload complete!");
  }catch(e){
    console.log(e);
  }
}

  const getFileNameFromURL = (url) => {
    const decodedURL = decodeURIComponent(url);

    const fileNameMatch = decodedURL.match(/\/o\/(.+)\?/);

    if (fileNameMatch && fileNameMatch[1]) {
      return fileNameMatch[1].split("/").pop();
    } else {
      return null;
    }
  };

  const handleEdit = async () => {
    setLoading(true);
    var response = 0;
    if (selectedFile) {
      const fileName = getFileNameFromURL(selectedAttachment.link);
      if (selectedAttachment.size && selectedAttachment.size != 0)
        response = await FirebaseServices.deleteFile(fileName);
      else response = 1;
      response === 1
        ? await handleUploadFile()
        : showError("An Error Occurred While Updating File");
    } else {
      updateWorkoutAttachment(attachmentLink);
    }
    setLoading(true);
  };
  const handleAdd = async () => {
    setLoading(true);
    if (selectedFile) {
      handleUploadFile();
    } else {
      addWorkoutAttachment(attachmentLink);
    }
  };

  const handleRemovingFile = async (data) => {
    var response = 0;
    setLoading(true);
    const fileName = getFileNameFromURL(data.link);
    if (data.size && data.size != 0)
      response = await FirebaseServices.deleteFile(fileName);
    else response = 1;
    response == 1
      ? await deleteWokroutAttachment(data)
      : showError("An Error Occurred While Deleting File");

    setLoading(false);
  };

  const uploadAttachment = () => {
    return (
      <UploadAttachment
        selectedFile={selectedFile}
        attachmetTitle={attachmetTitle}
        progress={progress}
      />
    );
  };
  const handleRemoveAttachment = (data) => {
    setSelectedAttachment(data);
    if (window.confirm("Are you sure you want to remove this Attachment?")) {
      handleRemovingFile(data);
    }
  };
  const handleAddAttachment = () => {
    setAttachmenttitle("");
    setAttachmetLink("");
    setShowModal(true);
  };
  const handleEditAttachment = (data) => {
    setSelectedAttachment(data);
    setAttachmenttitle("");
    setAttachmetLink("");
    setShowModal(true);
    setIsEdit(true);
  };
  const handleCloseModal = () => {
    setShowModal(false);
    setIsEdit(false);
  };
  return (
    <div className="pw_attachments-container">
      <ToastContainer />
      
      {loading && (
        <div className="pw_loading-overlay">
          <div className="pw_loading-spinner">
            <i className="fa fa-spinner fa-spin"></i>
            <span>Loading attachments...</span>
          </div>
        </div>
      )}

      <div className="pw_attachments-content">
        {/* Header Section */}
        <div className="pw_attachments-header">
          <div className="pw_header-info">
            <h1 className="pw_attachments-title">
              <i className="fa fa-paperclip" style={{ marginRight: '12px' }}></i>
              {workoutId == 0 ? "Program Attachments" : "Workout Attachments"}
            </h1>
            <p className="pw_attachments-subtitle">
              {workoutId == 0 
                ? "Add supporting materials, documents, and media files to your program"
                : "Add supporting materials, documents, and media files to your workout"
              }
            </p>
          </div>
          
          <button
            className={`pw_add-attachment-btn ${isUploading ? "pw_disabled" : ""}`}
            onClick={() => handleAddAttachment()}
            disabled={isUploading}
          >
            <i className="fa fa-plus" style={{ marginRight: '8px' }}></i>
            Add New Attachment
          </button>
        </div>

        {/* Attachments Grid */}
        <div className="pw_attachments-grid">
          {/* Upload Progress Card */}
          {isUploading && (
            <div className="pw_attachment-card pw_uploading-card">
              <div className="pw_upload-progress">
                <div className="pw_upload-icon">
                  <i className="fa fa-cloud-upload"></i>
                </div>
                <div className="pw_upload-info">
                  <h4>Uploading...</h4>
                  <div className="pw_progress-bar">
                    <div 
                      className="pw_progress-fill" 
                      style={{ width: `${progress}%` }}
                    ></div>
                  </div>
                  <span className="pw_progress-text">{progress}%</span>
                </div>
              </div>
            </div>
          )}

          {/* Existing Attachments */}
          {attachmentsList && attachmentsList.length > 0 ? (
            attachmentsList.map((attachment, index) => (
              <div key={index} className="pw_attachment-card">
                <AttachmentCard
                  attachment={attachment}
                  onEdit={() => handleEditAttachment(attachment)}
                  onRemove={() => handleRemoveAttachment(attachment)}
                />
              </div>
            ))
          ) : (
            !isUploading && (
              <div className="pw_empty-attachments" onClick={() => handleAddAttachment()}>
                <div className="pw_empty-icon">
                  <i className="fa fa-cloud-upload"></i>
                </div>
                <h3>No Attachments Yet</h3>
                <p>Click here to add your first attachment</p>
              </div>
            )
          )}
        </div>

        {/* Add/Edit Modal */}
        {showModal && (
          <div className="pw_modal-overlay">
            <div className="pw_modal-container">

              
              <AddAttachment
                handleCloseModal={handleCloseModal}
                attachmetTitle={attachmetTitle}
                setAttachmenttitle={setAttachmenttitle}
                attachmentLink={attachmentLink}
                setAttachmetLink={setAttachmetLink}
                selectedFile={selectedFile}
                setSelectedFile={setSelectedFile}
                isEdit={isEdit}
                attachment={selectedAttachment}
                handleEdit={handleEdit}
                handleAdd={handleAdd}
                progress={progress}
                isUploading={isUploading}
                accept={
                  ".jpg,.jpeg,.png,.gif,.webm,.bmp,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf,.mp4,.mp3,.avi,.mov"
                }
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

// AttachmentCard Component
const AttachmentCard = ({ attachment, onEdit, onRemove }) => {
  const [showImageModal, setShowImageModal] = useState(false);
  const [imageError, setImageError] = useState(false);

  const getFileIcon = (type) => {
    const fileType = type?.toLowerCase() || '';
    
    if (fileType.includes('image') || ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(fileType)) {
      return 'fa-image';
    } else if (fileType.includes('video') || ['mp4', 'avi', 'mov', 'mkv'].includes(fileType)) {
      return 'fa-video';
    } else if (fileType.includes('audio') || ['mp3', 'wav', 'ogg'].includes(fileType)) {
      return 'fa-music';
    } else if (['pdf'].includes(fileType)) {
      return 'fa-file-pdf';
    } else if (['doc', 'docx'].includes(fileType)) {
      return 'fa-file-word';
    } else if (['xls', 'xlsx'].includes(fileType)) {
      return 'fa-file-excel';
    } else if (['ppt', 'pptx'].includes(fileType)) {
      return 'fa-file-powerpoint';
    } else {
      return 'fa-file';
    }
  };

  const getFileTypeColor = (type) => {
    const fileType = type?.toLowerCase() || '';
    
    if (fileType.includes('image') || ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(fileType)) {
      return '#48bb78';
    } else if (fileType.includes('video') || ['mp4', 'avi', 'mov', 'mkv'].includes(fileType)) {
      return '#667eea';
    } else if (fileType.includes('audio') || ['mp3', 'wav', 'ogg'].includes(fileType)) {
      return '#ed8936';
    } else if (['pdf'].includes(fileType)) {
      return '#e53e3e';
    } else {
      return '#718096';
    }
  };

  const formatFileSize = (sizeInMB) => {
    if (!sizeInMB || sizeInMB === 0) return 'Unknown size';
    if (sizeInMB < 1) return `${(sizeInMB * 1024).toFixed(0)} KB`;
    return `${sizeInMB.toFixed(1)} MB`;
  };

  const isImage = (type) => {
    const fileType = type?.toLowerCase() || '';
    return fileType.includes('image') || ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg'].includes(fileType);
  };

  const handleImageError = () => {
    setImageError(true);
  };

  return (
    <div className="pw_attachment-item">
      <div className="pw_attachment-preview">
        {isImage(attachment.type) && attachment.link && !imageError ? (
          <div className="pw_image-preview">
            <img 
              src={attachment.link} 
              alt={attachment.title || 'Attachment image'}
              className="pw_attachment-image"
              onError={handleImageError}
              onClick={() => setShowImageModal(true)}
            />
            <div className="pw_image-overlay">
              <button 
                className="pw_view-image-btn"
                onClick={() => setShowImageModal(true)}
                title="View full image"
              >
                <i className="fa fa-search-plus"></i>
              </button>
            </div>
          </div>
        ) : (
          <div 
            className="pw_file-icon"
            style={{ color: getFileTypeColor(attachment.type) }}
          >
            <i className={`fa ${getFileIcon(attachment.type)}`}></i>
          </div>
        )}
        
        {attachment.link && (
          <a 
            href={attachment.link} 
            target="_blank" 
            rel="noopener noreferrer"
            className="pw_download-btn"
            title="Download file"
          >
            <i className="fa fa-download"></i>
          </a>
        )}
      </div>
      
      {/* Image Modal */}
      {showImageModal && isImage(attachment.type) && (
        <div className="pw_image-modal-overlay" onClick={() => setShowImageModal(false)}>
          <div className="pw_image-modal-container" onClick={(e) => e.stopPropagation()}>
            <div className="pw_image-modal-header">
              <h3>{attachment.title || 'Image Preview'}</h3>
              <button 
                className="pw_image-modal-close"
                onClick={() => setShowImageModal(false)}
              >
                <i className="fa fa-times"></i>
              </button>
            </div>
            <div className="pw_image-modal-content">
              <img 
                src={attachment.link} 
                alt={attachment.title || 'Attachment image'}
                className="pw_modal-image"
              />
            </div>
            <div className="pw_image-modal-actions">
              <a 
                href={attachment.link} 
                target="_blank" 
                rel="noopener noreferrer"
                className="pw_modal-download-btn"
              >
                <i className="fa fa-download" style={{ marginRight: '8px' }}></i>
                Download Image
              </a>
            </div>
          </div>
        </div>
      )}
      
      <div className="pw_attachment-info">
        <h4 className="pw_attachment-title">
          {attachment.title || 'Untitled'}
        </h4>
        
        <div className="pw_attachment-meta">
          <span className="pw_file-type">
            {attachment.type?.toUpperCase() || 'FILE'}
          </span>
          <span className="pw_file-size">
            {formatFileSize(attachment.size)}
          </span>
        </div>
      </div>
      
      <div className="pw_attachment-actions">
        <button 
          className="pw_action-btn pw_edit-btn"
          onClick={onEdit}
          title="Edit attachment"
        >
          <i className="fa fa-edit"></i>
        </button>
        
        <button 
          className="pw_action-btn pw_delete-btn"
          onClick={onRemove}
          title="Delete attachment"
        >
          <i className="fa fa-trash"></i>
        </button>
      </div>
    </div>
  );
};

export default WorkoutAttachments;
